export class Image {
  src = "";
  alt = "";
  constructor(src, alt) {
    this.src = src;
    this.alt = alt;
  }
}
